/** CoStar.Api.AptsReviews.ViewModels.Notification.ReviewNotificationStatus */
export var ReviewNotificationStatus;
(function (ReviewNotificationStatus) {
    ReviewNotificationStatus[ReviewNotificationStatus["Unhandled"] = 0] = "Unhandled";
    ReviewNotificationStatus[ReviewNotificationStatus["InProgress"] = 1] = "InProgress";
    ReviewNotificationStatus[ReviewNotificationStatus["Processed"] = 2] = "Processed";
    ReviewNotificationStatus[ReviewNotificationStatus["Error"] = 3] = "Error";
    ReviewNotificationStatus[ReviewNotificationStatus["Ignored"] = 4] = "Ignored";
})(ReviewNotificationStatus || (ReviewNotificationStatus = {}));
/** CoStar.Api.AptsReviews.ViewModels.Notification.CommentNotificationType */
export var CommentNotificationType;
(function (CommentNotificationType) {
    CommentNotificationType[CommentNotificationType["Unknown"] = 0] = "Unknown";
    CommentNotificationType[CommentNotificationType["User"] = 1] = "User";
    CommentNotificationType[CommentNotificationType["Reviewer"] = 2] = "Reviewer";
})(CommentNotificationType || (CommentNotificationType = {}));
/** CoStar.Api.AptsReviews.ViewModels.Notification.ReviewNotificationType */
export var ReviewNotificationType;
(function (ReviewNotificationType) {
    ReviewNotificationType[ReviewNotificationType["Unknown"] = 0] = "Unknown";
    ReviewNotificationType[ReviewNotificationType["User"] = 1] = "User";
    ReviewNotificationType[ReviewNotificationType["PropertyManagementCompany"] = 2] = "PropertyManagementCompany";
    ReviewNotificationType[ReviewNotificationType["EmailVerify"] = 3] = "EmailVerify";
})(ReviewNotificationType || (ReviewNotificationType = {}));
